<app-efa-navigation-ui
  [node]="node$ | async"
  [flyout]="false"
  [ngClass]="styleClass$ | async"
></app-efa-navigation-ui>
